const Backbone = require('backbone');
const CalculatorResultView = require('app/views/store/pages/paint/calculator_result');
const CalculatorModel = require('app/models/store/client/paint/calculator');

module.exports = Backbone.View.extend({
	el: '.js-paint-calculator',
	events: {
		'change .js-paint-input': 'onChangeInput',
		'click .js-paint-toggle': 'onClickToggle'
	},
	initialize: function() {
		this.$elemBody = this.$el.find('.js-paint-body');
		this.$elemToggleIconOpen = this.$el.find('.js-paint-toggle-icon-open');
		this.$elemToggleIconClose = this.$el.find('.js-paint-toggle-icon-close');

		this.childViews = {
			ceilingResults: new CalculatorResultView({ el: '.js-results-ceiling' }),
			wallsResults: new CalculatorResultView({ el: '.js-results-walls' }),
			trimResults: new CalculatorResultView({ el: '.js-results-trim' }),
			doorsResults: new CalculatorResultView({ el: '.js-results-doors' })
		};

		this.model = new CalculatorModel();

		this.listenTo(this.model, 'change:gallons-walls', (model, value) => this.childViews.wallsResults.updateQuantity(value));
		this.listenTo(this.model, 'change:gallons-doors', (model, value) => this.childViews.doorsResults.updateQuantity(value));
		this.listenTo(this.model, 'change:gallons-trim', (model, value) => this.childViews.trimResults.updateQuantity(value));
		this.listenTo(this.model, 'change:gallons-ceiling', (model, value) => this.childViews.ceilingResults.updateQuantity(value));
	},
	onChangeInput: function(e) {
		const $elem = $(e.currentTarget),
			value = $elem.val(),
			name = $elem.attr('name');
		if (name) {
			this.model.set(name, value);
		}
	},
	onClickToggle: function(e) {
		e.preventDefault();
		this.$elemBody.toggle();
		this.$elemToggleIconOpen.toggle();
		this.$elemToggleIconClose.toggle();
	}
});
